import { render, staticRenderFns } from "./HeadingAtom.vue?vue&type=template&id=1ea664c6&"
import script from "./HeadingAtom.vue?vue&type=script&lang=ts&"
export * from "./HeadingAtom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports